import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import Tooltip from "components/Tooltip";

const CertificationExporterItem = ({
  disabled,
  notAvailable,
}: {
  disabled: boolean;
  notAvailable?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      content={
        disabled ? t("buildingMaterialResources.exportNoLicenseTooltip") : ""
      }
      className={disabled ? "!cursor-not-allowed" : "cursor-pointer"}
    >
      <div
        key={2}
        className="w-full flex flex-row items-center justify-between"
      >
        <div
          className={clsx(
            notAvailable ? "text-gray-400" : "text-gray-900",
            "font-[400]"
          )}
        >
          {t("certificationExport.lifeCycleAssessment")}
          {notAvailable && (
            <span className="ml-1">{t("certificationExport.unavailable")}</span>
          )}
        </div>
      </div>
    </Tooltip>
  );
};

export default CertificationExporterItem;
